import { render, staticRenderFns } from "./statuses_selector.vue?vue&type=template&id=bdfd47b2"
import script from "./statuses_selector.js?vue&type=script&lang=js&external"
export * from "./statuses_selector.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports